import {
  Typography,
  MenuRoot,
  MenuTrigger,
  MenuItem,
  ButtonIcon,
  MenuContent,
} from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { ChallengeTimelineItemType } from 'features/challenge/ChallengeTimelineItem';
import { IChallenge } from 'features/challenge/config/types';
import {
  useDeletePlanningBacklogChallengesMutation,
  usePlanningAnalyticsEvents,
  useOpenEditBacklogChallengeDialog,
} from 'features/planning';

type TPlanningBacklogItemMenu = {
  challenge: IChallenge | ChallengeTimelineItemType;
};

export const PlanningBacklogMenu = ({
  challenge,
}: TPlanningBacklogItemMenu) => {
  const { sendPlanningChallengeRemovedEvent } = usePlanningAnalyticsEvents();

  const openEditChallengeModal = useOpenEditBacklogChallengeDialog({
    challenge,
  });

  const { mutateAsync: deleteChallenge } =
    useDeletePlanningBacklogChallengesMutation();

  const handleChallengeRemove = () => {
    sendPlanningChallengeRemovedEvent();

    deleteChallenge([challenge.challengeId!]);
  };

  return (
    <MenuRoot>
      <MenuTrigger asChild>
        <ButtonIcon
          aria-label="Options"
          data-testid="add-challenge-draft"
          variant="ghost"
        >
          <Icon name={iconNames.ellipsisHorizontal} />
        </ButtonIcon>
      </MenuTrigger>
      <MenuContent portalled={true}>
        <MenuItem
          onClick={openEditChallengeModal}
          _hover={{ outline: 'none', borderRadius: 'var(--border-radius)' }}
          width="100%"
        >
          <Typography color="black">Edit</Typography>
        </MenuItem>
        <MenuItem
          onClick={handleChallengeRemove}
          _hover={{ outline: 'none', borderRadius: 'var(--border-radius)' }}
          width="100%"
        >
          <Typography color="black">Remove</Typography>
        </MenuItem>
      </MenuContent>
    </MenuRoot>
  );
};
